window.addEventListener('load', function () {
  var $f5 = $('#x5-frame5');
  if ($f5.length === 0) return;

  var $menu = $f5.find('.f5-filter__menu');
  var $label = $f5.find('.f5-filter__label');

  $menu.on('click', 'a', function (e) {
    e.preventDefault();
    var $a = $(this);

    $menu.find('a').removeClass('active');
    $a.addClass('active');

    $label.text($a.text());

    $menu.removeClass('active');
  });
});
